// Register & Wizard
export const WIZARD = 'Wizard';
export const REGISTER = 'Register';

// Wizard Session Storage Constants
export const ERROR_MESSAGES = 'ErrorMessages';
export const BANK_DETAILS_BY_ROUTING_NUMBER = 'BankDetailsByRoutingNumber';

// Register Storage
export const APPLICATION_TYPE = 'ApplicationType';
export const APPLICATION_TYPE_STORAGE = 'ApplicationType';
export const ACCOUNT_TYPE = 'AccountType';
export const REGISTRATION_FLOW_TYPE = 'RegistrationFlowType';
export const OFFER_CODE = 'OfferCode';
export const LANDING_PAGE_URL = 'LandingPageUrl';
export const SAME_ADDRESS = 'SameAddress';
export const SKIPPED_STEP = 'SkippedStep';
export const EMAIL = 'Email';
export const APPLICATION_FUNDING_TYPE_STORAGE = 'ApplicationFundingType';
export const KYC_SELECTED_OPTION = 'SelectedOption';
export const NEW_APPLICATION = 'NewApplication';
export const KYC_SELECTED_TYPE = 'SelectedType';
export const IS_UPGRADE_FLOW = 'IsUpgradeFlow';
export const BASIC_ACCOUNT_QUERY_DATA = 'BasicAccountQueryData';
export const REFERRAL_CODE = 'ReferralCode';
export const REFERRER_EMAIL = 'referrerEmail';

// Sales assisted registration
export const IS_SALES_ASSESSTED_REGISTRATION_FLOW =
  'IsSalesAssesstedRegistrationFlow';
export const CUSTOMER_EMAIL = 'CustomerEmail';
// SIGNIFYD SESSION ID
export const SIGNIFYD_SESSION_ID = 'SignifydSessionId';

export const SALES_ASSISTED_QUERY_DATA = 'SalesAssistedQueryData';
export const USERNAMES = 'Usernames';

// ACOUNT TYPE BASED ON CHOOSE APPLICATION (USED FOR GTM EVENTS)
export const ACCOUNT_TYPE_GTM = 'AccountTypeGtm';

// EMPLOYMENT OPTIONS
export const EMPLOYMENT_STATUS_OPTIONS = 'EmploymentStatusOptions';
export const OCCUPATION_CATEGORIES = 'OccupationCategories';
export const OCCUPATIONS = 'Occupations';
export const INCOME_SOURCE_OPTIONS = 'SourceOfIncome';

export const BROKER_CODE = 'BROKER_CODE';
export const CONTENT_TYPE = 'ContentType';
